import * as ops from "@temp/modules"

export * from "@temp/modules"
export { getSVGIcon } from "./functions"
export default { ...ops }
